import React from 'react'

import { isLaunchedAsStandaloneApp } from '@/lib/mobile-app'

interface RestrictedMobileAppContentProps {
	fallback: React.ComponentType
}

export function RestrictedMobileAppContent({
	children,
	fallback: Fallback,
}: React.PropsWithChildren<RestrictedMobileAppContentProps>) {
	return <>{isLaunchedAsStandaloneApp() ? <Fallback /> : children}</>
}
